import { agencyScopeRequired, listPerm, superuser } from 'core/permissions';
import bank from 'modules/core/bank/permissions';
import activity from 'modules/core/activity/permissions';
import company from 'modules/core/company/permissions';

import category from 'modules/supplier/category/permissions';
import vendor from 'modules/supplier/vendor/permissions';
import serviceCategory from 'modules/supplier/outletOrServiceCategory/serviceCategoryPermissions';
import membership from 'modules/core/membership/permissions';
import brands from 'modules/client/brand/permissions';

export const preferencesMenu = {
  to: '/preferences',
  label: 'Preferences',
  icon: 'gear' as const,
  children: [
    { to: '/preferences/activities', label: 'Activities', visible: activity.view },
    { to: '/preferences/banks', label: 'Banks', visible: listPerm(bank) },
    { to: '/preferences/companies', label: 'Companies', visible: company.view },
    { to: '/preferences/brands', label: 'Brands', visible: brands.view },
    { to: '/preferences/vendors', label: 'Vendors', visible: vendor.view },
    { to: '/preferences/service_categories', label: 'Services', visible: serviceCategory.view },
    { to: '/preferences/categories', label: 'Categories', visible: category.view },
    { to: '/preferences/provided', label: 'Provided', visible: agencyScopeRequired },
    // @TODO move to system
    { to: '/preferences/ticket_assignees', label: 'Ticket assignees', visible: superuser },
    { to: '/preferences/membership', label: 'Membership', visible: membership.view },
  ],
};
